module.exports = __webpack_public_path__ + "img/lr-cb4-2-1.93fa2588.gif";